export default `
clip-path: url(#heart-clip-path);
`
